export const DeviceTypes = {
  PHONE: 'mobile',
  TABLET: 'tablet',
  DESKTOP: 'desktop',
};

export const AccountTypes = {
  ANONYMOUS: 'log-in',
  BASIC: 'basic',
  SUPER: 'super',
  SCHOOL_AND_DISTRICT: 'school-and-district',
  CORPORATE_INTRO: 'corporate-intro',
  CORPORATE_STANDARD: 'corporate-standard',
  CORPORATE_STANDARD_NONPROFIT: 'corporate-standard-nonprofit',
  CORPORATE_PREMIER: 'corporate-premier',
  CORPORATE_STARTER: 'corporate-starter',
  ENTERPRISE: 'enterprise',
  ESSENTIAL: 'essential',
  EVENT: 'event',
};

export const MobileNumberAuthEnabledCountries = ['IN', 'ID', 'TH', 'MY', 'PH'];
